/**
 * Closes the v-tooltip of an element. The directive hides on mouseleave/focusout only, which do
 * not fire when a modal opens on top of the element, so the portal tooltip would stay above it.
 */
export function hideTooltip(element: EventTarget | null): void {
  if (!(element instanceof HTMLElement)) return
  element.dispatchEvent(new MouseEvent('mouseleave'))
  element.dispatchEvent(new FocusEvent('focusout'))
  element.blur()
}
